
<form #otForm="ngForm">
  <div class="p-grid">
    <div class="p-col-12 p-md-4 p-lg-4">
      <label>User*</label>
    </div>
    <div class="p-col-12 p-md-8 p-lg-8">
      <p-dropdown name="selectedUser" [placeholder]="PrimeNgConfig.DropdownPlaceholder" [options]="userDropDown"
                  filter="true" [(ngModel)]="selectedUser" [readonly]="disableUserSwitch"
                  (onChange)="refreshOverTimeConfig()" required>
      </p-dropdown>
    </div>
  </div>

  <div class="p-grid">
    <div class="p-col-12 p-md-4 p-lg-4">
      <label>Year*</label>
    </div>
    <div class="p-col-12 p-md-8 p-lg-8">
      <p-dropdown name="selectedYear" [placeholder]="PrimeNgConfig.DropdownPlaceholder" [options]="yearDropDown"
                  filter="true" [(ngModel)]="selectedYear"
                  (onChange)="refreshOverTimeConfig()" required>
      </p-dropdown>
    </div>
  </div>
</form>


  <app-data-table [columns]="tableColumns" [value]="overtimeConfigs" [rightCaptionTemplate]="rightCaption"
                  sortField="periodStart"  [sortOrder]="PrimeNgConfig.TableAscSortOrder">
    <ng-template #rightCaption>
      <button *ngIf="overtimeConfigs?.length === 0 && allowEdit"
              pButton type="button" class="action-secondary" icon="fa fa-plus"
              label="OverTime Config"
              pTooltip="Generate OverTime Config" tooltipPosition="top" (click)="onClickShowConfiguration()"
              [disabled]="!otForm?.form?.valid">
      </button>
      <button *ngIf="overtimeConfigs?.length > 0 && allowEdit"
              pButton type="button" class="action-secondary" icon="fa fa-plus"
              label="Update OverTime Config"
              pTooltip="Update OverTime Config" tooltipPosition="top" (click)="onClickShowConfiguration()"
              [disabled]="!otForm?.form?.valid">
      </button>
    </ng-template>

    <ng-template #yearTemplate  let-row="row">
      <div>
        Period {{row?.periodNumber}} {{row?.year}}
      </div>
    </ng-template>


  </app-data-table>

  <p-dialog *ngIf="displayGenerateOvertimeDialog" [(visible)]="displayGenerateOvertimeDialog" header="Alternate Work Schedule"
            [dismissableMask]="true" [responsive]="true" [style]="PrimeNgConfig.DialogStyle40">

    <form #configForm="ngForm">
      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Long Week*</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <p-dropdown name="longWeek" [placeholder]="PrimeNgConfig.DropdownPlaceholder" [options]="timesheetPeriodOptions"
                      filter="true" [(ngModel)]="params.firstLongWeek"
                      required>
          </p-dropdown>
        </div>
      </div>

      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Long Week Working Hours*</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <input pInputText id="longWeekWorkingHours"
                 name="longWeekWorkingHours" type="number"
                 [pattern]="RegExp3DigitInteger2DigitFraction" pKeyFilter="pnum"
                 [(ngModel)]="params.longWeekWorkingHours"
                 required/>
        </div>
      </div>
      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Short Week*</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <p-dropdown name="firstShortWeek" [placeholder]="PrimeNgConfig.DropdownPlaceholder" [options]="timesheetPeriodOptions"
                      filter="true" [(ngModel)]="params.firstShortWeek"
                      required>
          </p-dropdown>
        </div>
      </div>

      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Short Week Working Hours*</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <input pInputText id="longWeekWorkingHours"
                 name="shortWeekWorkingHours" type="number"
                 [pattern]="RegExp3DigitInteger2DigitFraction" pKeyFilter="pnum"
                 [(ngModel)]="params.shortWeekWorkingHours"
                 required/>
        </div>
      </div>
    </form>



    <p-footer>
      <div style="text-align:right">
        <button pButton type="button" class="button-inaction" icon="fa fa-close" label="Close"
                (click)="onClickCancelGenerateConfiguration()"></button>
        <button pButton class="button-action" icon="fa fa-check" label="Generate"
                (click)="onClickGenerateConfiguration()"
                [disabled]="!configForm.form.valid"></button>
      </div>

    </p-footer>

  </p-dialog>

